import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { RedocSchema, ProStore, ProProviders } from "@redocly/reference-docs";
import * as React from "react";
import { GetStore } from "../../layouts/MarkdownLayout";
import { RedocComponentWrap } from "./styled.elements";

var JsonSchema = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(JsonSchema, _React$Component);

  function JsonSchema() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = JsonSchema.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        a = _this$props.definitionId,
        b = _this$props.pointer,
        c = _this$props.options,
        d = this.props.schema;

    if (d) {
      var _a = new ProStore({
        openapi: "3.0.0",
        info: {
          version: "1",
          description: "test",
          title: "test"
        },
        paths: {}
      }, void 0, {
        disableSearch: !0,
        disableSidebar: !0,
        ctrlFHijack: !1
      });

      return /*#__PURE__*/React.createElement(RedocComponentWrap, null, /*#__PURE__*/React.createElement(ProProviders, {
        store: _a,
        customOptions: c
      }, /*#__PURE__*/React.createElement(RedocSchema, {
        store: _a,
        schema: d
      })));
    }

    return /*#__PURE__*/React.createElement(RedocComponentWrap, null, /*#__PURE__*/React.createElement(GetStore, {
      definitionId: a
    }, function (a) {
      return /*#__PURE__*/React.createElement(ProProviders, {
        store: a,
        customOptions: c
      }, /*#__PURE__*/React.createElement(RedocSchema, {
        store: a,
        pointer: b
      }));
    }));
  };

  return JsonSchema;
}(React.Component);

export { JsonSchema as default };